import { Epic, ofType } from 'redux-observable';
import { from, Observable, of } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';

import { Action } from '../actions';
import {
    REQUEST_CLIENT_FREELANCER_DATA,
    updateClientFreelancerData
} from '../actions/clientFreelancerData';
import {
    mapClientFreelancer,
    mapFreelancerClient
} from '../mappers/freelancers';
import { EpicDeps } from '../service/StoreFactory';
import { State } from '../typings/state';

const NO_DATA_PAYLOAD = undefined;

export const requestClientFreelancerDataEpic: Epic<
    Action,
    Action,
    State,
    EpicDeps
> = (action$, store$, deps) =>
    action$.pipe(
        ofType(REQUEST_CLIENT_FREELANCER_DATA),
        mergeMap(
            (): Observable<Action> => {
                const ulogin = store$.value.commonData.login;
                const { authorizationData: auth } = store$.value.commonData;

                if (!auth) {
                    return of(updateClientFreelancerData(NO_DATA_PAYLOAD));
                }

                if (ulogin) {
                    return from(
                        deps.commonDataProvider
                            .fetchClientFreelancer(ulogin)
                            .then(response => {
                                if (response.errors) {
                                    // если есть ulogin (смотрим кампанию), но нет доступа - то нечего и показывать
                                    return Promise.resolve(NO_DATA_PAYLOAD);
                                }

                                const [
                                    project
                                ] = response.data.client.freelancerProjects;

                                if (project && project.freelancer) {
                                    // я фрилансер данного клиента,
                                    // показываем плашку клиента
                                    if (
                                        auth.login === project.freelancer.login
                                    ) {
                                        return mapFreelancerClient(
                                            response.data
                                        );
                                    }

                                    // если я не фрилансер, но ответ с проектом пришел - то я клиент или супер
                                    // показываем плашку фрилансера
                                    return mapClientFreelancer(response.data);
                                }

                                return deps.commonDataProvider
                                    .fetchClientFreelancer(auth.login)
                                    .then(({ data }) =>
                                        mapClientFreelancer(data)
                                    );
                            })
                    ).pipe(
                        mergeMap(
                            (data): Observable<Action> =>
                                of(updateClientFreelancerData(data))
                        ),
                        catchError(
                            (): Observable<Action> =>
                                of(updateClientFreelancerData(NO_DATA_PAYLOAD))
                        )
                    );
                }

                // в ином случае запросим фрилансеров текущего пользователя
                return from(
                    deps.commonDataProvider.fetchClientFreelancer(auth.login)
                ).pipe(
                    mergeMap(
                        (response): Observable<Action> => {
                            return of(
                                updateClientFreelancerData(
                                    mapClientFreelancer(response.data)
                                )
                            );
                        }
                    ),
                    catchError(
                        (): Observable<Action> =>
                            of(updateClientFreelancerData(NO_DATA_PAYLOAD))
                    )
                );
            }
        )
    );
